export default __webpack_public_path__ + "static/media/Cleaner.9c28d32f.jpg";